import instanciaAxios from './InterceptorAxios';

const servicioReceptor = {

    buscarReceptorPorRfc(receptor) {
        return instanciaAxios.post('/sinregistro/regimen/sinregistro_obtener_por_usocfdi_rfc.json', receptor);
    },
    buscarReceptorPorRfcAppRegistro(receptor) {
        return instanciaAxios.post('/regimen/registro_obtener_por_usocfdi_rfc.json', receptor);
    },
    guardar(receptor) {
        return instanciaAxios.post('receptor/guardar.json',receptor);
    },
    eliminar(receptor) {
        return instanciaAxios.post('receptor/eliminar.json',receptor);
    },
    rfcexiste(receptor){
        return instanciaAxios.post('receptor/rfcexiste.json',receptor);
    },
    buscarReceptorPorRfcRegistro(receptor){
        return instanciaAxios.post('receptor/buscarReceptorPorRfc.json',receptor);
    },
    buscarRfc(rfc){
        return instanciaAxios.post('receptor/buscarRfc.json',{rfc:rfc});
    },
    editarProveedor(id){
        return instanciaAxios.post('receptor/editarReceptor.json',{id:id});
    },
    validarReceptor(receptor){
        return instanciaAxios.post('receptor/validacion/validar_receptor40.json',receptor);
    }

}

export default servicioReceptor;